<template>
    <div class="step">
        <p
            class="text-sm font-medium text-slate-600 dark:text-slate-300 font-['Inter'] leading-5 mb-4"
        >
            How would you like to update points?
        </p>

        <!-- Manual updates option -->
        <label
            class="block relative cursor-pointer focus-within:ring-2 focus-within:ring-slate-300 focus-within:ring-offset-1 rounded-lg"
            @click="$emit('update:updateMethod', 'manual')"
        >
            <div
                class="flex items-start p-4 rounded-lg border-2 transition-all"
                :class="{
                    'border-orange': updateMethod === 'manual',
                    'border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 hover:bg-slate-50 dark:hover:bg-slate-700/50':
                        updateMethod !== 'manual',
                }"
            >
                <div class="flex-1">
                    <div class="flex items-center justify-between mb-2">
                        <Icon
                            icon="pencil"
                            class="w-5 h-5 text-slate-600 dark:text-slate-300"
                        />
                        <div
                            class="w-5 h-5 rounded-full flex items-center justify-center"
                            :class="{
                                'border-orange border-[6px] bg-white dark:bg-slate-800':
                                    updateMethod === 'manual',
                                'border-slate-300 dark:border-slate-600 border bg-white dark:bg-slate-800':
                                    updateMethod !== 'manual',
                            }"
                            style="box-sizing: border-box"
                        ></div>
                    </div>
                    <p
                        class="text-sm font-medium text-slate-800 dark:text-slate-100 font-['Inter'] leading-5 mb-1"
                    >
                        Manual updates
                    </p>
                    <p
                        class="text-sm font-normal text-slate-500 dark:text-slate-400 font-['Inter'] leading-5"
                    >
                        Manually update your points
                    </p>
                </div>
            </div>
        </label>
    </div>
</template>

<script setup>
import Icon from '@/components/ui/icon/icon.vue';

const props = defineProps({
    updateMethod: { type: String, required: true },
});

defineEmits(['update:updateMethod']);
</script>
